import { ol_Feature } from "@omnia/exports/openlayers"
import { isFieldViewModel } from "../../../omnia"
import { PlanAction } from "../../reducer"
import { MapFactory } from "../../types"
import { CroppingLayerStyle } from "./styles"

export class MapContext {

    private watcher: Function
    private selectedFieldId: number


    constructor(
        mapFactory: MapFactory,
        private readonly dispatch: React.Dispatch<PlanAction>,
        public readonly map = mapFactory({
            applyFilters: true,
            viewDefaultExtent: true,
            cacheGeometries: true
        })) {


        const { fieldsLayer: fields, croppingLayer: cropping } = map

        fields.selectable = true
        cropping.selectable = false

        const styles = new CroppingLayerStyle(cropping, () => this.selectedFieldId)

        cropping.styleProvider = s => styles.getLayerStyleFunction(s)

    }


    dispose() {
        this.map.dispose()
    }

    update({ selectedFieldId }: { selectedFieldId?: number }) {

        this.selectCurrentField(selectedFieldId)

    }

    enableSelection(enable: boolean) {
        this.map.enableSelection = enable
    }

    private selectCurrentField(fieldId: number) {

        const { watcher, map } = this

        if (watcher) {
            watcher()
        }

        const selectionChanged = this.selectedFieldId !== fieldId

        this.selectedFieldId = fieldId

        if (!fieldId) {

            map.selectFeatures([])

        }
        else {

            const features = map.fieldsLayer
                .findFeatures((_, data) => isFieldViewModel(data) && (data.fieldId === fieldId))
                .filter(f => !!f)

            const feature = features[0]

            map.selectFeatures(features)

            map.viewExtent(feature)


        }

        this.watcher = map.watchSelection(features => this.watchSelection(features || []))

        // Note: this is required because the cropping layer style depends on the selected field
        if (selectionChanged) {
            map.croppingLayer.refresh()
        }

    }

    private watchSelection(features: ol_Feature[]) {

        let fieldId = undefined as number

        if (features.length === 1) {

            const data = features[0].get("data")

            if (isFieldViewModel(data)) {
                fieldId = data.fieldId
            }

        }

        if (fieldId !== this.selectedFieldId) {
            this.dispatch({ type: "selectField", selectedFieldId: fieldId })
        }

    }

}
